import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { Table } from 'primeng/table';
import { Customer, Representative } from 'src/app/demo/api/customer';
import { TableConfig } from '../../models/TableConfigModel';
import * as Constants from '../../../core/constants/app.consts';
interface expandedRows {
    [key: string]: boolean;
}

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
})
export class TableComponent {
    customers1: Customer[] = [];
    representatives: Representative[] = [];
    statuses: any[] = [];
    zones$: any = Constants.zones;
    activityValues: number[] = [0, 100];
    @Input() tableConfig!: TableConfig;
    @Input() buttonText!: string;
    @Input() showButton: boolean = false;
    @Input() showUpdateOffer: boolean = false;
    @Input() showDeleteOffer: boolean = false;
    @ViewChild('filter') filter!: ElementRef;
    @Output() emitAdd = new EventEmitter();
    @Output() emitDelete = new EventEmitter();
    @Output() emitEdit = new EventEmitter();
    @Output() emitView = new EventEmitter();
    @Output() emitButtonEvent = new EventEmitter();
    @Output() emitPagination = new EventEmitter();
    @Output() emitStateFilter = new EventEmitter<string>();
    @Output() emitZoneFilter = new EventEmitter<string>();
    @Output() emitVenueTypeFilter = new EventEmitter<string>();
    stateOptions: any[] = [
        { label: 'Active', value: 'Active' },
        { label: 'Inactive', value: 'Inactive' },
        { label: 'De-registered', value: 'De-registered' },
    ];
    statusOptions: any[] = [
        { label: 'Active', value: true },
        { label: 'Inactive', value: false },
    ];
    venueTypes: any[] = [
        { label: 'FitX', value: 'champion' },
        { label: 'ZoneX', value: 'premium' },
        { label: 'Affiliate', value: 'affiliate' },
    ];
    selectedState: string | undefined = '';
    selectedStatus: string | undefined = '';
    selectedZone: string | undefined = '';
    selectedVenueType: string | undefined = '';
    originalTableData: any[] = [];
    constructor() { }

    ngOnInit() {
        this.originalTableData = [...this.tableConfig.tableData];
    }

    formatCurrency(value: number) {
        return value.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
    }

    onGlobalFilter(table: Table, event: Event) {
        table.filterGlobal(
            (event.target as HTMLInputElement).value,
            'contains'
        );
    }

    clear(table: Table) {
        // Clear search input
        this.filter.nativeElement.value = '';

        // Clear all custom filters
        this.selectedStatus = undefined;
        this.selectedState = undefined;
        this.selectedZone = undefined;
        this.selectedVenueType = undefined;

        // Clear date filters
        this.clearDateFilter();

        // Trigger any additional change handlers if needed
        this.onStateFilterChange(null);
        this.onZoneFilterChange(null);
        this.onVenueTypeFilterChange(null);

        // Clear PrimeNG internal filters LAST to trigger reload with clean state
        table.clear();
    }

    onAdd(event: any) {
        this.emitAdd.emit(event);
    }

    onStateFilterChange(event: any) {
        this.emitStateFilter.emit(this.selectedState);
    }

    onZoneFilterChange(event: any) {
        this.emitZoneFilter.emit(this.selectedZone);
    }

    onVenueTypeFilterChange(event: any) {
        this.emitVenueTypeFilter.emit(this.selectedVenueType);
    }

    //action event of table
    actionEvent(event: any, item: any) {
        if (event.eventType === 'EDIT') {
            this.emitEdit.emit(item);
        } else if (event.eventType === 'VIEW') {
            this.emitView.emit(item);
        } else if (event.eventType === 'DELETE') {
            this.emitDelete.emit(item);
        }
    }

    //button or icon event in table
    onButtonEvent(event: any, rowData: any, columnData: any) {
        let eventItem = { event, rowData, columnData };
        this.emitButtonEvent.emit(eventItem);
    }

    //pagination event
    pagination(event: any) {
        const page = event?.first !== undefined && event?.rows !== undefined
            ? Math.floor(event.first / event.rows) + 1
            : 1;

        const rows = event?.rows !== undefined ? event.rows : 10;

        const formatDate = (date: Date | null): string | null => {
            if (!date) return null;
            const d = new Date(date);
            const year = d.getFullYear();
            const month = (d.getMonth() + 1).toString().padStart(2, '0');
            const day = d.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const globalFilterObj: Record<string, any> = {
            searchText: event?.globalFilter ?? '',
            searchKey: 'isActive', // Always use fixed key for status
            searchValue: this.selectedStatus !== undefined ? this.selectedStatus : null, // use component value
            page: page,
            rows: rows,
            sortField: event?.sortField ?? null,
            sortOrder: event?.sortOrder ?? 1,
            fromDate: formatDate(this.filteredFromDate),
            toDate: formatDate(this.filteredToDate)
        };

        this.emitPagination.emit(globalFilterObj);
    }

    onStatusFilterChange() {
        // Trigger fresh pagination for new status selection
        const event = {
            first: 0,
            rows: this.tableConfig.pagesize,
            globalFilter: null,
        };
        this.pagination(event);
    }

    filteredFromDate: Date | null = null;
    filteredToDate: Date | null = null;

    applyDateFilter(): void {
        if (this.filteredFromDate && this.filteredToDate) {
            let start = new Date(this.filteredFromDate);
            let end = new Date(this.filteredToDate);

            if (start > end) {
                const temp = start;
                start = end;
                end = temp;
            }

            const normalizedStart = new Date(start);
            normalizedStart.setHours(0, 0, 0, 0);

            const normalizedEnd = new Date(end);
            normalizedEnd.setHours(23, 59, 59, 999);

            this.filteredFromDate = new Date(start);
            this.filteredToDate = new Date(end);

            // Trigger pagination with new dates
            const event = {
                first: 0,
                rows: this.tableConfig.pagesize,
                globalFilter: this.filter.nativeElement.value
            };
            this.pagination(event);
        }
    }

    clearDateFilter() {
        this.filteredFromDate = null;
        this.filteredToDate = null;
    }

}
